import classes from './SignInForm.module.css';
import { useContext, useRef } from 'react';
import axios from 'axios';
import qs from 'qs';
import {URL} from '../helpers/Options';
import UserContext from '../helpers/UserContext';

function SignInForm(props) {
	const userCtx = useContext(UserContext);
	const inputEmail = useRef();
	const inputPassword = useRef();
	const reply = useRef();

	function validateUser( event ) {
		event.preventDefault();
		const enteredEmail = inputEmail.current.value;
		const enteredPassword = inputPassword.current.value;
		reply.current.innerText="";
	
		var data = {
			action: 	'SAS_handleAJAX',
			function: 	'loginUser',
			username: 	enteredEmail,
			password: 	enteredPassword
		};
		axios.post(URL, qs.stringify(data)).then(
			function (response) {
				const tempUser = {
					email: response.data.data.user_email,
					firstName: response.data.data.first_name,
					lastName: response.data.data.last_name
				}
				if (response.data.data.user_email==="NONE") {
					reply.current.innerText="Username or password is wrong.";
				}
				else {
					userCtx.updateUser(tempUser); 
					userCtx.setSignups(response.data.data.signups);

				}
			}
		);
	}	
	console.log(window.reactPress);

	if (typeof userCtx.user.email == 'undefined' || userCtx.user.email === 'NONE') {
		return (
			<div className={classes.loginContainer}>
				<div className={classes.signinForm}>
					<div className={classes.header}><h1>Login</h1></div>
					<div className={classes.loginPane}>
					<p>If you've created an account already, log in here. You do not need an account to create cards.
						An account can be created after you sign up to make cards.
					</p>
						<p ref={reply} className={classes.message}></p>
						<form onSubmit={validateUser}>
							<label htmlFor="loginemail">Email:</label>
							<input className={classes.formInput} id="loginemail" type="email" ref={inputEmail} defaultValue=""/><br />
							<label htmlFor="password">Password:</label>
							<input className={classes.formInput}  id="password" type="text" ref={inputPassword} defaultValue="" />
							<button className={classes.btn}>Submit</button>
						</form>
					</div>
					<div className={classes.loginPane}>
						<h3>To create an account</h3>
						<p>After you click the "Signup" button for a project, a "Save my information for next time."
							button will be created. When you click this button is,
							you will receive an email. This email contains an activation 
							link to activate your account. You will need to create a password as well. 
							
						</p>
					</div>
					<div className={classes.why}>
						<p>You don't need to create and account. If you do, you will be able to save your information
							for next time and adjust your signups.
						</p>
					</div>
					<div className={classes.img}>
					<img src="https://abrightspot.org/wp-content/uploads/2023/11/Card-Makers2.webp" alt="Group making cards"/>
					</div>
				</div>
			</div>
		)	
	}
	else {
		return (
			<div>
				<h1>Welcome, {userCtx.user.firstName}</h1>
				<img src="https://abrightspot.org/wp-content/uploads/2023/11/Card-Makers2.webp" alt="Group making cards"/>
			</div>
		)
	}
}

export default SignInForm;
